// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"388":"result","446":"questionnaire"}[chunkId] + "." + {"388":"e3904a39","446":"22c36e4d"}[chunkId] + ".js";
};